import { lazy } from 'react';
//@import routes
const Home = lazy(() => import('pages/home/index'));
const Services = lazy(() => import('pages/services/index'));
const AssignPoints = lazy(() => import('pages/services/AssignPoints'));
const EvaluateSkills = lazy(() => import('pages/services/EvaluateSkills'));
const BatchHours = lazy(() => import('pages/services/BatchHours'));
const Sales = lazy(() => import('pages/sales/index'));
const Staff = lazy(() => import('pages/staff/index'));
const Finance = lazy(() => import('pages/finance/index'));
const Operations = lazy(() => import('pages/operations/index'));
const Trends = lazy(() => import('pages/trends/index'));
const Challenges = lazy(() => import('pages/challenges/index'));
const Rankings = lazy(() => import('pages/rankings/index'));
const Setup = lazy(() => import('pages/setup'));
const ProfilePage = lazy(() => import('pages/profile/index'));
const JumpStartWizard = lazy(() => import('pages/setup/pages/JumpStartWizard'));
const Sponsorships = lazy(() => import('pages/sponsorships/index'));
const Messaging = lazy(() => import('pages/messages/index'));
const Arena = lazy(() => import('pages/arena/index'));

export const AppRoutes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/profile',
    component: ProfilePage,
  },
  {
    path: '/messages',
    component: Messaging,
  },
  {
    path: '/services',
    component: Services,
  },
  {
    path: '/vendor/services',
    component: Services,
  },
  {
    path: '/services/assign-points',
    component: AssignPoints,
  },
  {
    path: '/services/evaluate-skills',
    component: EvaluateSkills,
  },
  {
    path: '/batches/:id/hours',
    component: BatchHours,
  },
  {
    path: '/sales/*',
    component: Sales,
  },
  {
    path: '/staff',
    component: Staff,
  },

  {
    path: '/finance',
    component: Finance,
  },
  {
    path: '/finance/payment-info',
    component: Finance,
  },
  {
    path: '/operations',
    component: Operations,
  },
  {
    path: '/trends',
    component: Trends,
  },
  {
    path: '/challenges/*',
    component: Challenges,
  },
  {
    path: '/rankings',
    component: Rankings,
  },
  {
    path: '/setup',
    component: Setup,
  },
  {
    path: '/setup/jumpstart',
    component: JumpStartWizard,
  },
  {
    path: '/onboarding/jumpstart',
    component: JumpStartWizard,
  },
  {
    path: '/sponsorships/*',
    component: Sponsorships,
  },
  {
    path: '/arena/*',
    component: Arena,
  },
];
